module.exports = __webpack_public_path__ + "imgs/share-link@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/share-link@2x.png
// module id = 227
// module chunks = 93